import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {authImageWidth} from 'styles/shared';

const FormContainer = styled.div`
  width: calc(100% - ${authImageWidth});
`;

const FormDiv = styled.div`
  text-align: center;
  margin-top: ${props => (props.isSignUp ? 0 : '13.6rem')};
`;

AuthBodyContainer.propTypes = {
  isSignUp: PropTypes.bool
};

function AuthBodyContainer({isSignUp, children}) {
  return (
    <FormContainer>
      <FormDiv isSignUp={isSignUp}>{children} </FormDiv>
    </FormContainer>
  );
}

export default AuthBodyContainer;
